import React from "react";
import { useEffect, useState, useRef } from "react";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
import { InputTextarea } from "primereact/inputtextarea";

export default function AcceptanceForm(props: any) {
  const [isAcceptanceTextEditing, setIsAcceptanceTextEditing] = useState(false);
  const labels = ["Your Full Name", "Company Name", "Contact Person", "Date", "Signature"];

  return (
    <div className="container p-0  border" >
      <section className="section-acceptance">
        <div className="row  px-3 ">
          <div className="col-12 ">
            <span className="h3 pt-2" style={{ borderTop: `2px solid ${props.secondaryColor}`, color: props.primaryColor }}>
              Acceptance Form{" "}
              {props.isEditable && !props.isGeneratingPdf ?
                <>
                  {!isAcceptanceTextEditing ? (
                    <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsAcceptanceTextEditing(true)} />
                  ) : (
                    <span className="text-12 ">
                      {isAcceptanceTextEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          onClick={() => {
                            setIsAcceptanceTextEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                          title="Save"
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsAcceptanceTextEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
                :
                null}
            </span>
            {isAcceptanceTextEditing ? (
              <InputTextarea
                value={props.acceptanceFormDescription}
                onChange={props.onAcceptanceFormDescriptionChange}
                autoResize
                className="text-12 w-100 mt-1"
              />
            ) : (
              <p className="small mb-1 mt-2">{props.acceptanceFormDescription}</p>
            )}
          </div>
         <div className="row">
            {labels.map((label, index) => {
              if (index % 2 === 0) {
                return (
                  <div className="row w-100" key={index}>
                    <div className="col-1"></div>

                    <div className="col-4 mt-5">
                      <p className="text-center" style={{ borderTop: `2px solid ${props.primaryColor}` }}>
                        {labels[index]}
                      </p>
                    </div>
                    <div className="col-2"></div>

                    {labels[index + 1] && (
                      <div className="col-4 mt-5">
                        <p className="text-center" style={{ borderTop: `2px solid ${props.primaryColor}` }}>
                          {labels[index + 1]}
                        </p>
                      </div>
                    )}

                    <div className="col-1"></div>
                  </div>
                );
              }
              return null;
            })}
          </div>

        </div>
      </section>
    </div>
  );
}
